import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['indicator']
  static values = {
    timeout: { type: Number, default: 2000 },
    scope: String
  }

  connect() {
    this.status = 'idle'
    this.wasDirty = false
    document.addEventListener('autosave:started', this.handleSaveStarted)
    document.addEventListener('autosave:success', this.handleSaveSuccess)
    document.addEventListener('autosave:failed', this.handleSaveFailed)
  }

  disconnect() {
    document.removeEventListener('autosave:started', this.handleSaveStarted)
    document.removeEventListener('autosave:success', this.handleSaveSuccess)
    document.removeEventListener('autosave:failed', this.handleSaveFailed)
    if (this.savedTimeout) clearTimeout(this.savedTimeout)
  }

  markDirty() {
    this.wasDirty = true
    this.setStatus('dirty')
  }

  handleSaveStarted = () => {
    if (this.wasDirty && this.status === 'dirty') {
      this.setStatus('saving')
    }
  }

  handleSaveSuccess = () => {
    if (this.wasDirty && (this.status === 'dirty' || this.status === 'saving')) {
      this.setStatus('saved')
      this.scheduleClearSaved()
      this.wasDirty = false
    }
  }

  handleSaveFailed = () => {
    if (this.wasDirty && this.status === 'saving') {
      this.setStatus('dirty')
    }
  }

  setStatus(status) {
    this.status = status
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.dataset.status = status
    }
  }

  scheduleClearSaved() {
    if (this.savedTimeout) clearTimeout(this.savedTimeout)
    this.savedTimeout = setTimeout(() => {
      if (this.status === 'saved') {
        this.setStatus('idle')
      }
    }, this.timeoutValue)
  }
}
